import { themeConstants } from '@paywithextend/components'
import {
  base_colorAlert,
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  base_contentSelected,
  red100,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  ${font_md}
  font-family: ${font_family_weight_medium};
  color: ${themeConstants.colors.cta};

  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${spacing(25)};
  padding: ${spacing(6)} ${spacing(4)};
  gap: ${spacing(2)};
  border: 1px dashed ${base_colorContentBorder};
  background-color: ${base_colorSurfaceSecondary};
  border-radius: ${cornerRadius};
  justify-content: center;
  cursor: pointer;

  .dropzone-input {
    &:focus {
      outline: none;
    }
  }

  // TRANSITIONS

  transition: background-color 100ms ease-out;
  span {
    transition: color 100ms ease-out;
  }
  svg path {
    transition: fill 100ms ease-out;
  }

  // HOVER

  &:hover {
    border-color: ${themeConstants.colors.cta};
    background-color: ${base_contentSelected};
  }

  // EMPTY AND REQUIRED

  &.isEmpty {
    width: 100%;

    &.isRequired {
      &,
      &:hover {
        color: ${base_colorAlert};
        background-color: ${red100 + '80'};
        border: 1px solid ${base_colorAlert};
        svg path {
          fill: ${base_colorAlert};
        }
      }
      &:hover {
        background-color: ${red100};
      }
    }
  }

  // DISABLED

  &.disabled {
    pointer-events: none;
    opacity: 50%;
  }
`
